import { FormulariosListSearchComponent } from './FormulariosListSearchComponent'
import { FormulariosListToolbar } from './FormulariosListToolbar'

export const FormulariosListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <FormulariosListSearchComponent actions={<FormulariosListToolbar />} />
    </div>
  )
}
